import { css } from "@emotion/react"
import styled from "@emotion/styled"
import Container from "components/Container"

const dinamicStyles = ({ theme, lowerText }) => css`
  ${lowerText &&
  `
    ${theme.breakpoints.down("xl")} {
      margin-bottom: 79px; 
    }

    ${theme.breakpoints.between("xl", "2xl")} {
      margin-bottom: 94px;  
    }

    ${theme.breakpoints.up("2xl")} {
      margin-bottom: 137px;  
    }
  `}
`

const ListThreeContainer = styled(Container)`
  ${dinamicStyles}

  ${({ theme }) => theme.breakpoints.up("xl")} {
    display: flex;
    justify-content: space-between;
    gap: 170px;
  }
`

export default ListThreeContainer
